import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiError } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null=checking, false=anon, obj=user
  const [ready, setReady] = useState(false);

  const finalizeGoogle = useCallback(async () => {
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      window.history.replaceState(null, "", window.location.pathname);
      if (sid) {
        try {
          const { data } = await api.post("/auth/google/session", { session_id: sid });
          localStorage.setItem("wf_token", data.token);
          setUser(data.user);
          return true;
        } catch (e) { /* fall through */ }
      }
    }
    return false;
  }, []);

  useEffect(() => {
    (async () => {
      const handled = await finalizeGoogle();
      if (handled) { setReady(true); return; }
      const token = localStorage.getItem("wf_token");
      if (!token) { setUser(false); setReady(true); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
      } catch (e) {
        localStorage.removeItem("wf_token");
        setUser(false);
      }
      setReady(true);
    })();
  }, [finalizeGoogle]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("wf_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("wf_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("wf_token");
    setUser(false);
  };
  const loginWithGoogle = () => {
    const redirect = `${window.location.origin}/dashboard`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, loginWithGoogle, setUser, apiError }}>
      {children}
    </AuthContext.Provider>
  );
}
